import type { SessionCollab } from "./context";

export function parseDateOrNull(
  isoDate: string | null | undefined,
): Date | null {
  if (!isoDate) {
    return null;
  }

  const timestamp = Date.parse(isoDate);
  if (Number.isNaN(timestamp)) {
    return null;
  }

  return new Date(timestamp);
}

export function mergeLatestDate(input: {
  existing: Date | null;
  incoming: Date | null;
}): Date | null {
  if (!input.incoming) {
    return input.existing;
  }
  if (!input.existing) {
    return input.incoming;
  }
  return input.incoming.getTime() > input.existing.getTime()
    ? input.incoming
    : input.existing;
}

export function areDatesEqual(input: {
  first: Date | null;
  second: Date | null;
}): boolean {
  if (!input.first && !input.second) {
    return true;
  }
  if (!input.first || !input.second) {
    return false;
  }
  return input.first.getTime() === input.second.getTime();
}

export function selectLatestCollabCreatedAt(input: {
  items: readonly SessionCollab[];
}): Date | null {
  return input.items.reduce<Date | null>(
    (latest, collab) =>
      mergeLatestDate({
        existing: latest,
        incoming: parseDateOrNull(collab.createdAt),
      }),
    null,
  );
}
